import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { KeyUri, config } from "../key";
import { toast } from "react-toastify";

const initialState = {
  currentPricing: null,
  loading: false,
  hasError: false,
};

export const pricingSlice = createSlice({
  name: "pricing",
  initialState,
  reducers: {
    getPricingRequest: (state) => {
      state.loading = true;
      state.hasError = false;
    },
    getPricingFailure: (state) => {
      state.loading = false;
      state.hasError = true;
    },
    getCurrentPricingSuccess: (state, { payload }) => {
      state.loading = false;
      state.currentPricing = payload?.price;
    },
  },
});

export const {
  getPricingRequest,
  getPricingFailure,
  getCurrentPricingSuccess,
} = pricingSlice.actions;

export const pricingSelector = (state) => state.pricing;





export const fetchPricingById = (adminId) => async (dispatch) => {
  dispatch(getPricingRequest());
  try {
    const { data } = await axios.get(KeyUri.BACKEND_URI + `/getPricemodal/${adminId}`, config);
    dispatch(getCurrentPricingSuccess(data));
  } catch (error) {
    dispatch(getPricingFailure());
  }
};

export const fetchpricingmodal = ()=>async(dispatch)=>{
  const token = JSON.parse(localStorage.getItem("token"));
    dispatch(getPricingRequest());
    try {
     
      const { data } = await axios.get(KeyUri.BACKEND_URI + `/get-all-pricemodals`,  {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      dispatch(getCurrentPricingSuccess(data));
    } catch (error) {
      dispatch(getPricingFailure());
    }
}






export default pricingSlice.reducer;
